// DocumentDownload.js
import React from 'react';

import DocumentDownloadListItem from './DocumentDownloadListItem';
//import DOMPurify from 'dompurify';
//import './DocumentDownload.css';

const DocumentDownload = ({ DocumentList = [], headline = '', introductionText = '', ariaLabel = '' }) => {

	const middleIndex = Math.ceil(DocumentList.length / 2);
	const leftItems = DocumentList.slice(0, middleIndex);
	const rightItems = DocumentList.slice(middleIndex);
  
	return (
		<div className="c-teaser c-teaser--vertical-50-50 t-bg-vibrant-turquoise-light u-padding-top-20">
			<div className="l-grid l-grid--max-width u-padding-top-20">
				<div className="l-grid__column-medium-10 offset-medium-1 c-component-header__headline-wrapper">
					{/* eslint-disable-next-line */}
					<a name="LegalDocuments">
						<h2 className="c-heading c-teaser__content__headline u-text-weight-light u-text-small-center-down u-text-center">
							{ headline }
						</h2>
					</a>
				</div>
				{ introductionText && 
					<p className="c-copy u-margin-bottom-none u-text-center u-text-small-center-down" tabIndex="0">
						{ introductionText }
					</p>
				}
				<div className="c-teaser__link-area" aria-label={ariaLabel}>
					<div className="c-teaser__content">
						<ul className="c-list c-list--icon c-list--small" >
							{leftItems.map((item, index) => (
        						<DocumentDownloadListItem item={item} key={index} />
							))}
						</ul>
					</div>
					<div className="c-teaser__content">
						<ul className="c-list c-list--icon c-list--small" >
							{rightItems.map((item, index) => (
								<DocumentDownloadListItem item={item} key={index} />
							))}
						</ul>
					</div>
				</div>
			</div>
		</div>
	)
}

export default DocumentDownload;